import TwoStepSignupForm from './two-step-signup-form-view';

export default TwoStepSignupForm;
